<template>
  <div>
    <b-modal
      :id="`publish-version-${service}`"
      centered
      title="Publish Version"
      hide-footer
    >
      <h5>The version for {{ extractServiceClass(service) }} is about to be <strong>Created</strong> and <strong>Published</strong> click on continue to proceed</h5>

      <b-button
        block
        :disabled="submitting"
        variant="success"
        @click="$emit('submit')"
      >
        Continue
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BButton,
} from 'bootstrap-vue'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'

export default {
  components: {
    BModal,
    BButton,
  },
  props: {
    service: {
      type: String,
      required: true,
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const extractServiceClass = service => snakeCaseToCamelCase(service.split('::')[1])
    return {
      extractServiceClass,
    }
  },
}
</script>
